<template>
    <div class="achievement-management">
        <!-- 引入通用表格组件 -->
        <UniversalDataTable
            :columns="achievementColumns"
            :form-fields="achievementFormFields"
            :table-data="tableData"
            :pagination="pagination"
            :form-rules="achievementFormRules"
            :enable-selection="true"
            :enable-edit="true"
            :enable-delete="true"
            :enableCategorySearch="true"
            :categoryOptions=options
            :categoryPlaceholder="'请选择成果类别'"
            :enable-excel-export="true"
            :export-confirm-message="exportMsg"
            @search="handleSearch"
            @create="handleCreate"
            @update="handleUpdate"
            @delete="handleDelete"
            @pagination-change="handlePaginationChange"
            @selection-change="handleSelectionChange"
            @category-change="handleCategoryChange"
            @export-excel="handleExport" />
    </div>
</template>

<script>
// 引入通用表格组件（路径与仪器管理一致）
import UniversalDataTable from '@/components/common/commonTable.vue';
import achievementApi from '@/api/achievements.js'; // 成果管理接口（需自行创建）
import institutionApi from '@/api/institution.js';//机构管理
import { DOWNLOAD_BASE_URL } from '@/api/base.js';

export default {
    name: 'AchievementManagement',
    components: {
        UniversalDataTable
    },
    data() {
        return {
            // 表格数据（从接口获取）
            tableData: [],
            institutionList: [], //机构列表
            // 分页配置
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            //搜索相关
            keyword: '',
            keycategory: "",
            error: null, // 错误提示,
            options: [
                { label: '医药', value: '医药' },
                { label: '医疗器械', value: '医疗器械' },
                { label: '保健品', value: '保健品' },
                { label: '装备制造', value: '装备制造' },
                { label: '其他', value: '其他' },
            ],
        };
    },
    computed: {
        //当前筛选信息
        exportMsg() {
            let msg = "";
            if (this.keyword && this.keyword != "") {
                msg += '您筛选的名称为:' + this.keyword + ","
            }
            if (this.keycategory && this.keycategory != "") {
                msg += "您筛选的分类为" + this.keycategory + ","
            }
            msg += "是否确定导出为excel文件？"
            return msg;
        },
        // 分页基础地址
        baseUrl() {
            return `/achievements?pageNum=${this.pagination.currentPage}&pageSize=${this.pagination.pageSize}`;
        },
        keywordUrl() {
            return `/achievements?projectName=${this.keyword}&pageNum=${this.pagination.currentPage}&pageSize=${this.pagination.pageSize}&category=${this.keycategory}`;
        },
        // 表格列配置（对应 Achievement 实体字段）
        achievementColumns() {
            return [
                {
                    prop: 'id',
                    label: '成果ID',
                    width: 100,
                    align: 'center'
                },
                {
                    prop: 'projectName',
                    label: '项目名称',
                    width: 200
                },
                {
                    prop: 'category',
                    label: '类别',
                    width: 120,
                    align: 'center'
                },
                {
                    prop: 'projectIntroduction',
                    label: '项目介绍',
                    // 超长文本截取（hover显示完整内容）
                    formatter: (value) => {
                        if (!value) return '';
                        return value.length > 10 ? `${value.slice(0, 10)}...` : value;
                    }
                },
                {
                    prop: 'projectProgress',
                    label: '项目进度',
                    width: 120,
                    align: 'center',
                },
                {
                    prop: 'intellectualPropertyStatus',
                    label: '知识产权状况',
                    width: 180
                },
                {
                    prop: 'proposedTransformationMethod',
                    label: '拟转化方式',
                    width: 180
                },
                {
                    prop: 'proposedTransformationAmount',
                    label: '拟转化金额',
                    width: 150,
                    align: 'center',
                    formatter: (value) => value || '无'
                },
                {
                    prop: 'contactPerson',
                    label: '联系人',
                    width: 120
                },
                {
                    prop: 'contactInfo',
                    label: '联系方式',
                    width: 150
                },
                {
                    prop: 'institution', // 关联机构名称（机构对象的属性）
                    label: '所属机构',
                    width: 180,
                    formatter: (value, row) => {
                        return row?.institution?.name || '未关联机构';
                    }
                },
                {
                    prop: 'createTime',
                    label: '创建时间',
                    width: 200,
                    align: 'center',
                    // 时间格式化
                    formatter: (value) => {
                        if (!value) return '';
                        return new Date(value).toLocaleString();
                    }
                },
                {
                    prop: 'updateTime',
                    label: '更新时间',
                    width: 200,
                    align: 'center',
                    formatter: (value) => {
                        if (!value) return '';
                        return new Date(value).toLocaleString();
                    }
                }
            ];
        },
        // 表单字段配置（新增/编辑弹窗用）
        achievementFormFields() {
            return [
                {
                    prop: 'projectName',
                    label: '项目名称',
                    type: 'input',
                    required: true,
                    props: {
                        placeholder: '请输入项目名称'
                    }
                },
                {
                    prop: 'category',
                    label: '类别',
                    type: 'select',
                    options: this.options,
                    required: true,
                    props: {
                        placeholder: '请输入项目类别（如：技术成果、专利、软件著作权等）'
                    }
                },
                {
                    prop: 'projectIntroduction',
                    label: '项目介绍',
                    type: 'input',
                    required: true,
                    props: {
                        type: 'textarea',
                        rows: 5,
                        placeholder: '请详细描述项目成果（功能、优势、应用场景等）'
                    }
                },
                {
                    prop: 'projectProgress',
                    label: '项目进度',
                    type: 'select', // 下拉选择器（固定选项）
                    required: true,
                    options: [
                        { label: '未录入', value: '未录入' },
                        { label: '已立项', value: '已立项' },
                        { label: '开发中', value: '开发中' },
                        { label: '已应用', value: '已应用' }
                    ],
                    props: {
                        placeholder: '请选择项目进度'
                    }
                },
                {
                    prop: 'intellectualPropertyStatus',
                    label: '知识产权状况',
                    type: 'input',
                    required: false,
                    props: {
                        placeholder: '请输入知识产权状况（如：已授权专利、申请中、无等）'
                    }
                },
                {
                    prop: 'proposedTransformationMethod',
                    label: '拟转化方式',
                    type: 'input',
                    required: false,
                    props: {
                        placeholder: '请输入拟转化方式（如：技术转让、合作开发、自主转化等）'
                    }
                },
                {
                    prop: 'proposedTransformationAmount',
                    label: '拟转化金额',
                    type: 'input',
                    required: false,
                    props: {
                        type: 'number',
                        min: 0,
                        placeholder: '请输入拟转化金额（单位：元，非必填）'
                    }
                },
                {
                    prop: 'contactPerson',
                    label: '联系人',
                    type: 'input',
                    required: false,
                    props: {
                        placeholder: '请输入联系人'
                    }
                },
                {
                    prop: 'contactInfo',
                    label: '联系方式',
                    type: 'input',
                    required: false,
                    props: {
                        placeholder: '请输入联系方式（电话/微信等）'
                    }
                },
                {
                    prop: 'platform',
                    label: '所属机构',
                    type: 'select', // 改为下拉选择
                    required: true,
                    options: this.institutionList.map(item => ({
                        label: item.name, // 下拉显示机构名称
                        value: item.id // 选中后表单存储机构ID
                    })), // 下拉选项：映射机构列表
                    props: {
                        placeholder: '请选择所属机构',
                        clearable: true
                    },
                    hint: '选择已存在的机构，自动关联机构ID' // 提示文案优化
                },
            ];
        },
        // 表单验证规则
        achievementFormRules() {
            return {
                projectName: [
                    { required: true, message: '请输入项目名称', trigger: 'blur' }
                ],
                category: [
                    { required: true, message: '请输入项目类别', trigger: 'blur' }
                ],
                projectIntroduction: [
                    { required: true, message: '请输入项目介绍', trigger: 'blur' },
                    { min: 10, message: '项目介绍不少于10个字符', trigger: 'blur' }
                ],
                projectProgress: [
                    { required: true, message: '请选择项目进度', trigger: 'change' }
                ],
                platform: [
                    { required: true, message: '请输入所属机构ID', trigger: 'blur' },
                    { type: 'number', message: '机构ID必须为数字', trigger: 'blur' }
                ]
                // 非必填字段无需添加验证规则
            };
        }
    },
    mounted() {
        // 页面加载时获取成果列表
        this.loadInstitutionList().then(() => {
            this.loadAchievementList(this.keywordUrl);
        });
    },
    methods: {
        // ---------------------- 数据接口相关 ----------------------
        //加载机构列表
        async loadInstitutionList() {
            try {
                const res = await institutionApi.getList(); // 调用机构接口
                this.institutionList = res.data || []; // 存储机构列表
            } catch (err) {
                this.$message.error('加载机构列表失败，请刷新重试');
                console.error('加载机构出错:', err);
            }
        },
        // 加载成果列表数据
        async loadAchievementList(url) {
            try {
                const response = await this.$http.get(url);
                this.pagination.total = response.data.total;
                this.tableData = response.data.records;
                this.error = null;
            } catch (err) {
                this.error = '数据加载失败，请稍后重试';
                console.error('加载成果数据出错:', err);
            }
        },

        // ---------------------- 通用表格回调函数 ----------------------
        // 搜索回调（按项目名称关键词搜索）
        handleSearch(keyword) {
            console.log('搜索关键词：', keyword);
            this.keyword = keyword
            this.pagination.currentPage = 1;
            this.loadAchievementList(this.keywordUrl);
        },
        //分类切换事件发请求
        handleCategoryChange(val) {
            console.log('选中的分类：', val);
            this.keycategory = val ? val : "";
            this.loadAchievementList(this.keywordUrl);
        },
        // 新增成果回调
        async handleCreate(formData) {
            console.log('新增成果数据：', formData);
            try {
                const res = await achievementApi.create(formData);
                if (res.code === 200) {
                    this.$message.success(res.msg || '新增成果成功');
                    this.loadAchievementList(this.baseUrl);
                }
            } catch (error) {
                this.$message.error('新增失败：' + (error.msg || '网络错误'));
            }
        },

        // 编辑成果回调
        async handleUpdate(formData) {
            try {
                // 确保携带主键ID（后端通过ID更新）
                if (!formData.id) {
                    this.$message.error('成果ID不能为空');
                    return;
                }
                const res = await achievementApi.update(formData);
                if (res.code === 200) {
                    this.$message.success(res.msg || '编辑成果成功');
                    this.loadAchievementList(this.baseUrl);
                }
            } catch (error) {
                this.$message.error('编辑失败：' + (error.msg || '网络错误'));
            }
        },

        // 删除成果回调
        async handleDelete(row) {
            console.log('删除成果ID：', row.id);
            try {
                const res = await achievementApi.delete(row.id);
                if (res.code === 200) {
                    this.$message.success(res.msg || '删除成果成功');
                    this.loadAchievementList(this.baseUrl);
                }
            } catch (err) {
                this.$message.error('删除失败：' + (err.msg || '网络错误'));
            }
        },

        // 分页变化回调
        handlePaginationChange(pagination) {
            this.pagination = pagination;
            if (this.keyword != '') {
                this.loadAchievementList(this.keywordUrl);
            } else {
                this.loadAchievementList(this.baseUrl);
            }
            console.log('分页变化：', pagination);

        },

        // 选择行变化回调（批量操作用）
        handleSelectionChange(selectedRows) {
            console.log('选中的成果：', selectedRows);
            // 可扩展批量删除、批量导出等功能
        },
        //excel导出
        handleExport() {
            this.loadAchievementList(this.keywordUrl)
            if (this.total == 0) {
                his.$message.error("未找到符合条件的数据信息")
            }
            //发请求导出
            // 2. 拼接请求参数
            const params = new URLSearchParams();
            params.append('projectName', this.keyword || ''); // 你的搜索关键词
            params.append('category', this.keycategory || ''); // 你的分类筛选值


            // 2. 拼接完整的下载URL
            const baseUrl = DOWNLOAD_BASE_URL + '/achievements/excel'; // 接口路径
            const downloadUrl = `${baseUrl}?${params.toString()}`;

            // 3. 打开新标签页触发下载
            const newTab = window.open(downloadUrl, '_blank');

            // 4. 可选：处理下载失败/无数据的情况（新标签页会显示后端返回的错误信息）
            setTimeout(() => {
                // 如果新标签页没关闭（说明下载没触发，大概率是接口返回了错误）
                if (newTab && !newTab.closed) {
                    // 关闭空标签页
                    // newTab.close();
                    // 提示用户错误信息
                    this.$message.error('导出失败：暂无符合条件的数据');
                }
            }, 2000);
        }
    }
};
</script>

<style scoped>
.achievement-management {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

/* 解决表格中el-tag样式穿透问题 */
::v-deep .el-table .el-tag {
    display: inline-block;
    vertical-align: middle;
}
</style>